export function tokenGetter() {
  const token  = localStorage.getItem('token');
  return token ? JSON.parse(token) : null;
}
